import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export const useDeleteWebhookTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.webhook.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.webhook.list.queryKey(),
        });
      },
    }),
  });

  return {
    deleteWebhook: async (id: string) => mutation.mutateAsync({ id }),
    loading: mutation.isPending,
    error: mutation.error,
  };
};
